<template>
    <v-form @submit.prevent="submitForm" class="pa-0 k-card-border z-index-1" v-if="fielddata && users">
        {{ fielddata }}
        <div class="pa-1 rounded-lt-lg">
            <userstagmenu class="my-auto" type="chip" :users="users" :selected="selectedUser" show_names
                @update:value="updateAssignee" />
        </div>
        <div class="pa-3">
            <v-row class="">
                <v-col cols="6">
                    <v-text-field v-model="fielddata.hours" type="text" @input="validateHours" inputmode="numeric"
                        min="0" suffix="Uren" density="compact" variant="solo" hide-details></v-text-field>
                </v-col>
                <v-col cols="6" class="text-right">
                    <v-text-field v-model="fielddata.minutes" type="text" @input="validateMinutes" inputmode="numeric"
                        min="0" max="59" suffix="Minuten" density="compact" variant="solo" hide-details> </v-text-field>
                </v-col>
                <v-col cols="12">
                    <VueDatePicker v-model="dateTimeRange" :format="'dd-MM-yyyy HH:mm'"
                        @update:modelValue="updateTicket" :clearable="true" :locale="'nl'" range multi-calendars
                        :show-time="true" placeholder="Datum en tijd" />
                </v-col>
                <v-col cols="12">
                    <v-text-field prepend-inner-icon="fal fa-text" v-model="fielddata.description" placeholder="Notitie"
                        variant="solo" density="compact" hide-details></v-text-field>
                </v-col>
            </v-row>
        </div>
        <div class="pa-3 py-2 d-flex my-auto">
            <div>
                <v-switch inset v-model="fielddata.billable" color="primary" classs="billable-switch" label="Billable"
                    density="compact" hide-details></v-switch>
            </div>
            <v-spacer></v-spacer>
            <div>
                <v-btn class="btn btn-sm" color="primary" type="submit" block>Opslaan</v-btn>
            </div>
        </div>
    </v-form>

</template>

<script>

export default {
    name: "TimeTrackingMenu",
    props: {
        timeSpent: { type: Array, required: true },
        taskId: { type: Number, default: null },
        ticketId: { type: Number, default: null },
        users: { type: Array, required: true },
        current_user_id: { type: Number, required: true },
        fielddata: {
            type: Object,
            default: () => ({
                hours: '',
                minutes: '',
                time: '',
                user_id: '',
                start_time: '',
                end_time: '',
                description: '',
                billable: false
            })
        }
    },

    data() {
        return {
            menuVisible: true,
            dateTimeRange: [null, null],
            editDialog: false,
            editedTime: '',
            currentEdit: null
        };
    },
    computed: {
        totalTimeInMinutes() {
            return (parseInt(this.fielddata.hours) || 0) * 60 + (parseInt(this.fielddata.minutes) || 0);
        },
        formattedTotalTime() {
            const totalMinutes = this.timeSpent.reduce((sum, entry) => sum + entry.time, 0);
            return this.formatTime(totalMinutes);
        },
        groupedTime() {
            return this.timeSpent.reduce((acc, entry) => {
                const userId = entry.user_id;
                if (!acc[userId]) {
                    acc[userId] = {
                        user: this.users.find(user => user.id === userId),
                        totalTime: 0
                    };
                }
                acc[userId].totalTime += entry.time;
                return acc;
            }, {});
        },
        selectedUser() {
            if (!this.fielddata.user_id) {
                this.fielddata.user_id = this.current_user_id;
                return this.current_user_id;
            } else {
                return this.fielddata.user_id;
            }
        },
        formattedDate() {
            if (this.fielddata.start_time && this.fielddata.end_time) {
                return `${this.formatDate(this.fielddata.start_time)} - ${this.formatDate(this.fielddata.end_time)}`;
            } else {
                return 'Selecteer een datumbereik';
            }
        }
    },
    created() {
        this.setDefaultDateTime();
    },
    watch: {
        "fielddata.hours": "updateTotalTime",
        "fielddata.minutes": "updateTotalTime",
        "fielddata.time": "updateTotalTime",
        "fielddata.user_id": "updateAssignee",

        dateTimeRange(newRange) {
            this.updateTimeRange(newRange);
        },

    },
    methods: {
        setDefaultDateTime() {
            const now = new Date();
            const startOfDay = new Date(now.setHours(0, 0, 0, 0));
            const endOfDay = new Date(startOfDay.getTime() + (60 * 60 * 1000));

            if (!this.dateTimeRange[0] && !this.dateTimeRange[1]) {
                this.dateTimeRange = [startOfDay, endOfDay];
            }

            this.fielddata.start_time = this.dateTimeRange[0].getTime() / 1000;
            this.fielddata.end_time = this.dateTimeRange[1].getTime() / 1000;
        },
        updateTimeRange(dateRange) {
            if (dateRange && dateRange[0] && dateRange[1]) {
                this.fielddata.start_time = new Date(dateRange[0]).getTime() / 1000;
                this.fielddata.end_time = new Date(dateRange[1]).getTime() / 1000;
                this.calculateTimeDifference();
            }
        },
        calculateTimeDifference() {
            if (this.fielddata.start_time && this.fielddata.end_time) {
                const startDate = new Date(this.fielddata.start_time * 1000);
                const endDate = new Date(this.fielddata.end_time * 1000);

                const diffInMilliseconds = endDate - startDate;
                const diffInMinutes = Math.floor(diffInMilliseconds / 60000); // Minuten
                const hours = Math.floor(diffInMinutes / 60); // Uren
                const minutes = diffInMinutes % 60; // Rest van de minuten

                this.fielddata.hours = hours;
                this.fielddata.minutes = minutes;
            }
        },
        validateHours() {
            this.fielddata.hours = this.fielddata.hours.replace(/\D/g, '');
        },
        validateMinutes() {
            this.fielddata.minutes = this.fielddata.minutes.replace(/\D/g, '');
            if (parseInt(this.fielddata.minutes) > 59) {
                this.fielddata.minutes = 59;
            }
        },
        updateTotalTime() {
            this.fielddata.time = (parseInt(this.fielddata.hours) || 0) * 60 + (parseInt(this.fielddata.minutes) || 0);
        },
        updateAssignee(usersId) {
            console.log('user', usersId);
            this.fielddata.user_id = usersId;
        },
        formatTime(minutes) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            return `${hours}u ${remainingMinutes}m`;
        },
        submitForm() {
            const payload = {
                task_id: this.taskId,
                ticket_id: this.ticketId,
                user_id: this.fielddata.user_id = parseInt(this.fielddata.user_id, 10),
                time: parseInt(this.fielddata.time),
                start: this.fielddata.start_time,
                end: this.fielddata.end_time,
                source: "manual",
                billable: this.fielddata.billable,
                description: this.fielddata.description,
            };

            this.$emit("add-time", payload);
            this.resetForm();
        },
        resetForm() {
            this.fielddata = {
                time: '',
                start_time: '',
                end_time: '',
                description: '',
                user_id: '',
                billable: false
            };
        },
        updateTicket(dateRange) {
            // Update this with the values of the new range
            if (dateRange && dateRange[0] && dateRange[1]) {
                this.fielddata.start_time = new Date(dateRange[0]).getTime() / 1000;
                this.fielddata.end_time = new Date(dateRange[1]).getTime() / 1000;
                this.calculateTimeDifference();
            }
        }
    }
};
</script>


<style>
.z-index-1 {
    z-index: 1;
    overflow: visible !important;
}


:root {
    /*General*/
    --dp-font-family: 'Gilroy';
    --dp-border-radius: 8px;
    /*Configurable border-radius*/
    --dp-cell-border-radius: 6px;
    /*Specific border radius for the calendar cell*/
    --dp-common-transition: all 0.1s ease-in;
    /*Generic transition applied on buttons and calendar cells*/

    /*Sizing*/
    --dp-button-height: 35px;
    /*Size for buttons in overlays*/
    --dp-month-year-row-height: 35px;
    /*Height of the month-year select row*/
    --dp-month-year-row-button-size: 35px;
    /*Specific height for the next/previous buttons*/
    --dp-button-icon-height: 20px;
    /*Icon sizing in buttons*/
    --dp-cell-size: 35px;
    /*Width and height of calendar cell*/
    --dp-cell-padding: 5px;
    /*Padding in the cell*/
    --dp-common-padding: 10px;
    /*Common padding used*/
    --dp-input-icon-padding: 35px;
    /*Padding on the left side of the input if icon is present*/
    --dp-input-padding: 6px 30px 6px 12px;
    /*Padding in the input*/
    --dp-menu-min-width: 260px;
    /*Adjust the min width of the menu*/
    --dp-action-buttons-padding: 2px 5px;
    /*Adjust padding for the action buttons in action row*/
    --dp-row-margin: 5px 0;
    /*Adjust the spacing between rows in the calendar*/
    --dp-calendar-header-cell-padding: 0.5rem;
    /*Adjust padding in calendar header cells*/
    --dp-two-calendars-spacing: 10px;
    /*Space between multiple calendars*/
    --dp-overlay-col-padding: 3px;
    /*Padding in the overlay column*/
    --dp-time-inc-dec-button-size: 32px;
    /*Sizing for arrow buttons in the time picker*/
    --dp-menu-padding: 6px 8px;
    /*Menu padding*/

    /*Font sizes*/
    --dp-font-size: 16px;
    /*Default font-size*/
    --dp-preview-font-size: 14px;
    /*Font size of the date preview in the action row*/
    --dp-time-font-size: 14px;
    /*Font size in the time picker*/

    /*Transitions*/
    --dp-animation-duration: 0.1s;
    /*Transition duration*/
    --dp-menu-appear-transition-timing: cubic-bezier(.4, 0, 1, 1);
    /*Timing on menu appear animation*/
    --dp-transition-timing: ease-out;
    /*Timing on slide animations*/
}

.dp__theme_light {
    --dp-background-color: #fff;
    --dp-text-color: #212121;
    --dp-hover-color: #f3f3f3;
    --dp-hover-text-color: #212121;
    --dp-hover-icon-color: #959595;
    --dp-primary-color: #24a1c7;
    --dp-primary-disabled-color: #24a1c750;
    --dp-primary-text-color: #f8f5f5;
    --dp-secondary-color: #c0c4cc;
    --dp-border-color: #ddd;
    --dp-menu-border-color: #ddd;
    --dp-border-color-hover: #aaaeb7;
    --dp-border-color-focus: #aaaeb7;
    --dp-disabled-color: #f6f6f6;
    --dp-scroll-bar-background: #f3f3f3;
    --dp-scroll-bar-color: #959595;
    --dp-success-color: #76d275;
    --dp-success-color-disabled: #a3d9b1;
    --dp-icon-color: #959595;
    --dp-danger-color: #ff6f60;
    --dp-marker-color: #ff6f60;
    --dp-tooltip-color: #fafafa;
    --dp-disabled-color-text: #8e8e8e;
    --dp-highlight-color: rgb(25 118 210 / 10%);
    --dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);
    --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);
    --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);
}
</style>